var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDinner(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58.034 58.034",
    style: {
      enableBackground: "new 0 0 58.034 58.034"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M50.034,45.017h-42c-1.825,0-1.538-2.882-2.599-4.367l-5.26-3.165c-0.439-0.615,0-1.469,0.756-1.469 h56.174c0.755,0,1.195,0.854,0.756,1.469l-5.226,3.165C51.573,42.136,51.86,45.017,50.034,45.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBD490"
    },
    d: "M53.089,34.57c-0.604-0.41-0.975-1.085-0.9-1.812c0.025-0.241,0.018-0.48-0.044-0.686 c-0.232-0.761-0.877-1.37-1.652-1.55c-0.358-0.083-1.027-0.049-1.027-0.066c0-1.026-0.832-1.857-1.857-1.857 c-0.406,0-0.929-0.175-0.929-0.464c0-1.237-0.97-2.238-2.189-2.308c-0.123,0.146-0.275,0.269-0.471,0.325l-2.884,0.827 c-0.529,0.151-1.085-0.157-1.237-0.686l-0.528-1.842c-1.85-0.12-3.643-0.183-5.362-0.192c-0.125,1.542-1.401,2.759-2.976,2.759 c-1.516,0-2.756-1.128-2.958-2.589c-2.217,0.138-4.282,0.345-6.151,0.597l-2.446,2.713c-0.311,0.345-0.843,0.373-1.189,0.062 l-0.978-0.881c-0.323-0.291-0.356-0.771-0.106-1.115c-1.958,0.385-3.572,0.783-4.787,1.117l-0.843,1.608 c-0.255,0.487-0.863,0.677-1.35,0.422l-2.163-1.133c-0.146,0.203-0.228,0.429-0.19,0.683c0.21,1.404-1.241,2.535-2.096,2.564 c-0.704,0.024-0.92,1.472-0.886,2.176c0.006,0.121-1.857,0.832-1.857,1.857c0,0.276,0.061,0.538,0.169,0.772 c0.022,0.047,0.026,0.097,0.043,0.146h50.802C53.924,35.419,53.578,34.902,53.089,34.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7E2BF"
    },
    d: "M13.517,31.397c-0.194,0-0.39-0.057-0.563-0.174c-0.456-0.312-0.574-0.934-0.263-1.39l0.781-1.146 c0.311-0.457,0.934-0.573,1.39-0.263c0.456,0.312,0.574,0.934,0.263,1.39l-0.781,1.146C14.151,31.245,13.836,31.397,13.517,31.397z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA5E35"
    },
    d: "M10.227,28.952L7.57,27.56c-0.487-0.255-0.677-0.863-0.422-1.35l1.392-2.657 c0.255-0.487,0.863-0.677,1.35-0.422l2.657,1.392c0.487,0.255,0.677,0.863,0.422,1.35l-1.392,2.657 C11.322,29.018,10.714,29.207,10.227,28.952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7E2BF"
    },
    d: "M10.848,33.746c-0.179,0-0.36-0.048-0.524-0.149l-1.181-0.729c-0.47-0.29-0.615-0.905-0.325-1.376 c0.289-0.47,0.903-0.618,1.376-0.325l1.181,0.729c0.47,0.29,0.615,0.905,0.325,1.376C11.511,33.577,11.183,33.746,10.848,33.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7E2BF"
    },
    d: "M15.558,35.409c-0.041,0-0.082-0.002-0.124-0.008c-0.548-0.067-0.938-0.567-0.869-1.115l0.171-1.377 c0.067-0.548,0.566-0.939,1.115-0.869c0.548,0.067,0.938,0.567,0.869,1.115l-0.171,1.377 C16.487,35.039,16.056,35.409,15.558,35.409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7E2BF"
    },
    d: "M18.937,31.854c-0.026,0-0.052-0.001-0.078-0.003l-1.383-0.107c-0.551-0.043-0.963-0.523-0.92-1.074 c0.043-0.552,0.525-0.968,1.074-0.92l1.383,0.107c0.551,0.043,0.963,0.523,0.92,1.074C19.892,31.456,19.454,31.854,18.937,31.854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7E2BF"
    },
    d: "M22.784,34.888c-0.194,0-0.39-0.057-0.563-0.174c-0.456-0.311-0.574-0.933-0.263-1.39l0.781-1.146 c0.312-0.458,0.933-0.572,1.39-0.263c0.456,0.311,0.574,0.933,0.263,1.39l-0.781,1.146C23.418,34.736,23.104,34.888,22.784,34.888z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7E2BF"
    },
    d: "M23.105,30.251c-0.179,0-0.36-0.048-0.524-0.149L21.4,29.373c-0.47-0.29-0.615-0.905-0.325-1.376 c0.289-0.47,0.903-0.618,1.376-0.325l1.181,0.729c0.47,0.29,0.615,0.905,0.325,1.376C23.768,30.082,23.44,30.251,23.105,30.251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7E2BF"
    },
    d: "M45.105,33.742c-0.194,0-0.391-0.057-0.563-0.174c-0.456-0.312-0.574-0.934-0.263-1.39l0.782-1.146 c0.311-0.457,0.936-0.573,1.39-0.263c0.456,0.312,0.574,0.934,0.263,1.39l-0.782,1.146C45.739,33.59,45.424,33.742,45.105,33.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7E2BF"
    },
    d: "M42.896,30.746c-0.179,0-0.36-0.048-0.524-0.149l-1.181-0.729c-0.47-0.29-0.615-0.905-0.325-1.376 c0.288-0.469,0.904-0.618,1.376-0.325l1.181,0.729c0.47,0.29,0.615,0.905,0.325,1.376C43.559,30.577,43.231,30.746,42.896,30.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7E2BF"
    },
    d: "M28.49,29.509c-0.025,0-0.052-0.001-0.078-0.003l-1.384-0.107c-0.551-0.043-0.963-0.523-0.92-1.074 s0.512-0.957,1.074-0.92l1.384,0.107c0.551,0.043,0.963,0.523,0.92,1.074C29.446,29.111,29.008,29.509,28.49,29.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7E2BF"
    },
    d: "M39.493,37.077c-0.026,0-0.053-0.001-0.079-0.003l-1.383-0.108 c-0.551-0.043-0.962-0.524-0.919-1.075s0.535-0.948,1.075-0.919l1.383,0.108c0.551,0.043,0.962,0.524,0.919,1.075 C40.448,36.679,40.01,37.077,39.493,37.077z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7E2BF"
    },
    d: "M29.107,34.017c-0.086,0-0.173-0.011-0.26-0.034l-1.34-0.359c-0.534-0.143-0.851-0.691-0.707-1.225 c0.144-0.534,0.694-0.851,1.225-0.707l1.34,0.359c0.534,0.143,0.851,0.691,0.707,1.225C29.951,33.723,29.548,34.017,29.107,34.017z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7E2BF"
    },
    d: "M34.285,33.437c-0.425,0-0.818-0.271-0.953-0.697c-0.167-0.526,0.124-1.089,0.65-1.256l1.323-0.42 c0.531-0.169,1.09,0.125,1.256,0.65c0.167,0.526-0.124,1.089-0.65,1.256l-1.323,0.42C34.488,33.423,34.385,33.437,34.285,33.437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7E2BF"
    },
    d: "M32.106,31.017c-0.257,0-0.514-0.099-0.709-0.295c-0.39-0.392-0.388-1.025,0.004-1.414l0.984-0.979 c0.392-0.391,1.024-0.388,1.414,0.004s0.388,1.025-0.004,1.414l-0.984,0.979C32.615,30.921,32.361,31.017,32.106,31.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7E2BF"
    },
    d: "M40.105,33.359c-0.442,0-0.848-0.296-0.966-0.744l-0.354-1.342 c-0.141-0.534,0.178-1.082,0.711-1.223c0.532-0.142,1.082,0.176,1.223,0.711l0.354,1.342c0.141,0.534-0.178,1.082-0.711,1.223 C40.276,33.348,40.19,33.359,40.105,33.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7E2BF"
    },
    d: "M37.277,28.015c-0.026,0-0.053-0.001-0.079-0.003l-1.384-0.108 c-0.551-0.043-0.962-0.524-0.919-1.075c0.043-0.552,0.531-0.956,1.075-0.919l1.384,0.108c0.551,0.043,0.962,0.524,0.919,1.075 C38.232,27.618,37.793,28.015,37.277,28.015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7994D"
    },
    d: "M39.9,26.293l-0.827-2.884c-0.152-0.529,0.157-1.085,0.686-1.237l2.884-0.827 c0.529-0.152,1.085,0.157,1.237,0.686l0.827,2.884c0.152,0.529-0.157,1.085-0.686,1.237l-2.884,0.827 C40.608,27.13,40.051,26.822,39.9,26.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDD807"
    },
    d: "M24.189,19.293l-0.827-2.884c-0.152-0.529,0.157-1.085,0.686-1.237l2.884-0.827 c0.529-0.152,1.085,0.157,1.237,0.686l0.827,2.884c0.152,0.529-0.157,1.085-0.686,1.237l-2.884,0.827 C24.897,20.13,24.341,19.822,24.189,19.293z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F6A36E"
    },
    cx: 31.034,
    cy: 24.017,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FBB50C"
    },
    cx: 15.034,
    cy: 20.017,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71B43D"
    },
    d: "M23.708,23.047l-4.229,4.692c-0.311,0.345-0.843,0.373-1.189,0.062l-0.978-0.881 c-0.345-0.311-0.373-0.843-0.062-1.189l4.229-4.692c0.311-0.345,0.843-0.373,1.189-0.062l0.978,0.881 C23.992,22.169,24.019,22.702,23.708,23.047z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98DF2A"
    },
    d: "M35.256,20.533l-2.17-5.932c-0.16-0.437,0.065-0.92,0.501-1.08l1.237-0.452 c0.437-0.16,0.92,0.065,1.08,0.501l2.17,5.932c0.16,0.437-0.065,0.92-0.501,1.08l-1.237,0.452 C35.899,21.194,35.416,20.969,35.256,20.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M49.034,42.017H18.02c-0.553,0-1-0.447-1-1s0.447-1,1-1h31.015c0.553,0,1,0.447,1,1 S49.587,42.017,49.034,42.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M13.106,42.017H9.034c-0.553,0-1-0.447-1-1s0.447-1,1-1h4.071c0.553,0,1,0.447,1,1 S13.658,42.017,13.106,42.017z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinner);
export default __webpack_public_path__ + "static/media/dinner.8b09308f01528adc727fc74f3a5ac644.svg";
export { ForwardRef as ReactComponent };